import { useState } from "react";
import t from "@/lang/lang";
import {
  FeatureAuthTable,
  FeatureAuthTableFilters,
} from "@/services/backend/auth/components/feature-auth-table";
import { FeatureAuthCreateDialog } from "@/services/backend/auth/components/feature-auth-create-dialog";
import { ListRequest } from "@/services/backend/auth/api/feature-auth";
import {
  BaseDataPage,
  BaseDataPageContent,
  BaseDataPageDescription,
  BaseDataPageHeader,
  BaseDataPageTitle,
} from "../../_components/layout/base-data-page";

export function FeatureAuthRoute() {
  const [request, setRequest] = useState<ListRequest>({
    orderBy: [{ field: "feature" }],
    limit: 20,
    offset: 0,
  });

  return (
    <BaseDataPage>
      <BaseDataPageHeader>
        <BaseDataPageTitle>{t("Feature Authorisierung")}</BaseDataPageTitle>
        <BaseDataPageDescription>
          {t(
            "Hier können ausgewählte Feature für bestimmte Rollen und Unternehmen eingeschränkt werden.",
          )}
        </BaseDataPageDescription>
      </BaseDataPageHeader>
      <BaseDataPageContent>
        <div className="flex flex-col gap-2">
          <div className="flex items-center justify-between">
            <FeatureAuthTableFilters
              request={request}
              onRequestChange={setRequest}
            />
            <FeatureAuthCreateDialog />
          </div>
          <FeatureAuthTable request={request} onRequestChange={setRequest} />
        </div>
      </BaseDataPageContent>
    </BaseDataPage>
  );
}
